import store from '@/store'
const ChangePassword = () => import('@/components/change-password/ChangePassword');
const ForgotPassword = () => import('@/components/forgot-password/ForgotPassword');
const Home = () => import('@/components/home/Home');
const HomeLayout = () => import('@/components/home-layout/HomeLayout');
const Login = () => import('@/components/login/Login');
const TermsAndConditions = () => import('@/components/terms-and-conditions/TermsAndConditions');
const UpdatePassword = () => import('@/components/update-password/UpdatePassword');

const AuthorizationLayout = () => import('@/components/authorization/AuthorizationLayout');

const AddAuthorizationLayout = () => import('@/components/dynamic-authorization/new/add-authorization/AddAuthorizationLayout');
const AddGuestAuthorizationLayout = () => import('@/components/dynamic-authorization/new/add-guest-authorization/AddGuestAuthorizationLayout')
const AuthorizationDetailLayout = () => import('@/components/dynamic-authorization/find/detail/AuthorizationDetailLayout')
const AuthorizationGuestDetailLayout = () => import('@/components/dynamic-authorization/find/guest-detail/AuthorizationGuestDetailLayout')

const GuestLayout = () => import('@/components/guest-layout/GuestLayout')
const PrescriptionLayout = () => import('@/components/prescription/PrescriptionLayout');
const NewPrescription = () => import('@/components/prescription/new-prescription/NewPrescription');
const Profile = () => import('@/components/profile/Profile')
const Register = () => import('@/components/profile/Register')
const GuestApplicationProfileRequest = () => import('@/components/profile/GuestApplicationProfileRequest');
const ApplicationProfile = () => import('@/components/profile/ApplicationProfile')
const EditProfile = () => import('@/components/profile/EditProfile')
const EmailNotification = () => import('@/components/tfa/EmailNotification');
const EmailVerification = () => import('@/components/tfa/EmailVerification')

const areUserPrerequisitesValid = (to, from, next) => {

  if (!store.getters.isAuthenticated) {
    return next('/login')
  }
   
  if (store.getters.passwordRotationRequired && !store.getters.passwordRotationUpdated) { 
    return next('/change-password-required')
  }

  if(store.getters.requiresTwoFactorAuthentication){ 
    if(!store.getters.hasValidTwoFactorVerification){
      return next('/tfa-email-verification')
    }
  } 
  
  if (store.getters.isTermsAndConditionsAcceptanceRequired) { 
    return next('/terms-and-conditions')
  }

  return next()
}

const areUserGuest = (to, from, next) => {
  if (store.getters.isGuest == true) {
    return next()
  }

  return next('/login')
}

const requireTfa = (to, from, next) => {
  if(!store.getters.isAuthenticated && store.getters.requiresTwoFactorAuthentication){
    return next()
  }
  next('/login')
}

const prerequisiteValidated = (to, from, next) => {

  if (!store.getters.isAuthenticated) { return next('/login') }

  if (to.name === 'ChangePasswordRequired') { 
    if (!store.getters.passwordRotationRequired || store.getters.passwordRotationRequired && store.getters.passwordRotationUpdated) {
      return next('/home')
    } 
    
  } else if (to.name === 'TermsAndConditions') {   

    if (!store.getters.isTermsAndConditionsAcceptanceRequired) {
      return next('/home')
    } 

  } else if (to.name === 'EmailVerification'){ 

    if (!store.getters.requiresTwoFactorAuthentication || store.getters.requiresTwoFactorAuthentication && store.getters.hasValidTwoFactorVerification) { 
      return next('/home')
    }

  }

  return next()
}


const routes = [
  {
    path: '/login',
    name: 'Login',
    component: Login,
  },
  {
    path: '/register',
    name: 'Register',
    component: Register    
  },
  {
    path: '/guest',
    name: 'Guest',
    component: GuestLayout,
    beforeEnter: areUserGuest,
    children: [
      {
        path: 'new',
        name: 'NewGuestRequest',
        component: AddGuestAuthorizationLayout,
      },
      {
        path: 'detail',
        name: 'DetailGuestRequest',
        component: AuthorizationGuestDetailLayout
      },
      {
        path: 'profile-status',
        name: 'ProfileStatusRequest',
        component: GuestApplicationProfileRequest
      },
      {
        path: 'application-profile',
        name: 'ApplicationProfile',
        component: ApplicationProfile
      }
    ]
  },
  {
    path: '/',
    component: HomeLayout,
    beforeEnter: areUserPrerequisitesValid,
    redirect: { name: 'Home' },
    children: [
      {
        path: '/home',
        name: 'Home',
        component: Home,
      },
      {
        path: '/update-password',
        name: 'UpdatePassword',
        component: UpdatePassword,
      },
      {
        path: '/profile',
        name: 'Profile',
        component: Profile,
      },
      {
        path: '/edit-profile',
        name: 'EditProfile',
        component: EditProfile
      }
    ]
  },
  {
    path: '/change-password-required',
    name: 'ChangePasswordRequired',
    component: UpdatePassword,
    beforeEnter: prerequisiteValidated,
    props: { rotationRequiredFlow: true }
  },
  {
    path: '/forgot-password',
    name: 'ForgotPassword',
    component: ForgotPassword,
  },
  {
    path: '/change-password',
    name: 'ChangePassword',
    component: ChangePassword,
    props: (route) => ({ token: route.query.token }),
  },
  {
    path: '/terms-and-conditions',
    name: 'TermsAndConditions',
    component: TermsAndConditions,
    beforeEnter: prerequisiteValidated
  },
   {
    path: '/email-notification',
    name: 'EmailNotification',
    component: EmailNotification,
    beforeEnter: requireTfa
  },
  {
    path: '/tfa-email-verification',
    name: 'EmailVerification',
    component: EmailVerification,
  },
  {
    path: '/request',
    component: AuthorizationLayout,
    beforeEnter: areUserPrerequisitesValid,
    children: [
      {
        path: 'new',
        name: 'NewAuthorization',
        component: AddAuthorizationLayout,
        beforeEnter: areUserPrerequisitesValid,
      },
      {
        path: ':request',
        name: 'AuthorizationDetail',
        component: AuthorizationDetailLayout,
        beforeEnter: areUserPrerequisitesValid,
      },
    ]
  },
  {
    path: '/prescription',
    component: PrescriptionLayout,
    beforeEnter: areUserPrerequisitesValid,
    children: [
      {
        path: 'new',
        name: 'NewPrescription',
        component: NewPrescription,
        beforeEnter: areUserPrerequisitesValid
      }
    ]
  },
  {
    path: '*',
    redirect: { name: 'Home'}
  }
]

export default routes;